// Third Party Imports
import React from 'react';

// Relative Imports
import ConfirmBrandButton from '../Button/ConfirmBrandButton';
import './ConfirmBrandButtonHolder.less';
import { getCurrencySymbol } from '../../utils/constants';

export default class ConfirmBrandButtonHolder extends React.Component {
    constructor(props) {
        super(props);
    }

    displayCurrencyList(currencyList) {
        return currencyList.map((currency, index) => (
            <span key={currency}>
                {currency} {getCurrencySymbol(currency) || ''}{index < currencyList.length - 1 && <span>{' or '}</span>}
            </span>
        ));
    }

    renderConfirmBrandButton() {
        const {
            enableContinueButton,
            handleConfirmBrandButtonClick,
            continueButtonId,
            data,
            brandImage,
            flagImage
        } = this.props;

        return (
            <ConfirmBrandButton
                brandImage={brandImage}
                flagImage={flagImage}
                language={data.locale}
                domain={data.domain}
                currencies={this.displayCurrencyList(data.currencies)}
                confirmBrand={handleConfirmBrandButtonClick}
                buttonId={continueButtonId}
                enableButton={enableContinueButton}
            />
        )
    }

    render() {
        return (
            <div className="confirm-brand-continue-button-holder">
                {this.renderConfirmBrandButton()}
            </div>
        );
    }
}
